module.exports = __webpack_public_path__ + "static/img/record.adac69cc.png";